/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import GoogleZoom from '../components/GoogleZoom'
import Calendar from '../calendar/Calendar'

var outsideDocument = ''

const DocumentVans = (props) => {
    var CryptoJS = require("crypto-js");
    const [ valueForSubmit, setValueForSubmit ] = useState('')
    const [ dateSelected, setDateSelected ] = useState(new Date())
    const [ dateSelectedTwo, setDateSelectedTwo ] = useState(new Date())
    const [ calendarGate, setCalendarGate] = useState(false)
    const [ calendarGateTwo, setCalendarGateTwo] = useState(false)
    const [ nameFromListArray, setNameFromListArray] = useState([])
    const [ nameFromList, setNameFromList] = useState('')
    const [ damageNameFromList, setDamageNameFromList] = useState('')
    const [ damageNamesListArray, setDamageNamesListArray] = useState([])
    const [ displayNameArray, setDisplayNameArray ] = useState('names_list_array_container_none')
    const [ damageDisplayNameArray, setDamageDisplayNameArray ] = useState('names_list_array_container_none')
    const [ submitPressed, setSubmitPressed] = useState('Submit')
    const [ vanDocuments, setVanDocuments ] = useState([])
    const [ submitFilesDivSelection, setSubmitFilesDivSelection ] = useState(false)
    const [ buttonText, setButtonText ] = useState('Add Document')
    const [ classForDiv, setClassForDiv ] = useState('submit_files')
    const [ highlightedPicture, setHighlightedPicture ] = useState(null)
    const [ highlightedImageDetails, setHighlitedImageDetails ] = useState(null)
    const [ currentId, setCurrentId ] = useState(0)
    const [ damageGate, setDamageGate ] = useState(false)
    const [ textAreaValue, setTextAreaValue] = useState('')
    const [ damageData, setDamageData ] = useState([])
    const [ damageDescriptions, setDamageDescriptions ] = useState([])
    const [ deleteScreen, setDeleteScreen ] = useState(null)
    const [ dateGate, setDateGate ] = useState(true)
    const [ dateContent, setDateContent ] = useState(null)
    const [ submitFilesDiv, setSubmitFilesDiv] = useState(null)
    const [ damageContent, setDamageContent ] = useState(null)
    const [ theCalendar, setTheCalendar ] = useState(null)
    const [ anotherPage, setAnotherPage ] = useState(null)
    const [ newPageNumber, setNewPageNumber ] = useState(1)
    const [ rerenderBool, setRerenderBool ] = useState(0)

    // save image to cloudinary
    var uploadImage = (e) => {
        const files = e.target.files
        const data = new FormData()
        data.append('file', files[0])
        data.append('upload_preset', process.env.REACT_APP_UPLOAD_PRESET)
        data.append("api_key", process.env.REACT_APP_CLOUDINARY_API_KEY)
        axios.post(process.env.REACT_APP_UPLOAD_IMAGE, data).then(response => {
            let myOtherResponse = ''
            // if (response.data.secure_url.includes('.pdf')) {
            //     let myNewName = response.data.secure_url.replace(/.pdf/, '.png')
            //     response.data.secure_url = myNewName
            // }
            // setValueForSubmit(myOtherResponse ? myOtherResponse : response.data.secure_url)
            setValueForSubmit(response.data.secure_url)
            outsideDocument = response.data.secure_url
        })
    }

    useEffect( () => {
        async function getData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });

            return response ? response.json() : console.log('no reponse')

        };
        getData(`https://backendpajamas.herokuapp.com/vehicledamages/`).then( response => {
            setDamageData(response.results)
        })
    }, [damageGate, props])


    // onClick={(e, vanItem) => handleMakingMainImage(e, vanDoc.picturesOfIncident, vanDoc)}
    useEffect( () => {
        let localArray = []
        // console.log(props)
        if (damageData) {
            damageData.forEach( vanDoc => {
                // console.log(vanDoc)
                // console.log(props.selectedVan.vehicle_id)
                if (parseInt(vanDoc.vehicle_id.split('/')[4]) === props.selectedVan.vehicle_id) {
                    localArray.push(
                        <div className='spacer_div_vans_list'>
                            <div className='h3_for_compliance_Page_ralph' >
                                {vanDoc.name}
                                <img src={vanDoc.picturesOfIncident} alt="Folder" className='image_in_documents_folder'/>
                            </div>
                        </div>
                    )
                }
            })
        }
        setDamageDescriptions(localArray)
    }, [damageData, props])

    useEffect( () => {
        if (props.selectedVan) {
            let localArray = []
            async function postData(url = '', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    }, 
                    body: JSON.stringify(data)
                });
    
                return response ? response.json() : console.log('no reponse')
            };
            postData(`https://backendpajamas.herokuapp.com/vansingleimage/`, {
                van_id: props.selectedVan.vehicle_id
            }).then( response => {
                if (response.data) {
                    response.data.forEach( (vanDoc, vanDocId) => {
                        if (!vanDoc.storageBool) {
                            if (vanDoc.imagesLink.includes('.pdf')) {
                                let pageString = 'pg_1/'
                                let begginingOfUrl = vanDoc.imagesLink.slice(0, 53)
                                let endOfUrlUrl = vanDoc.imagesLink.slice(53)
                                let endUrlString = begginingOfUrl.concat(pageString).concat(endOfUrlUrl)
                                let pngUrlPdf = endUrlString.replace(/.pdf/, '.png')
                                if (vanDoc.verified === 'True') {
                                    localArray.push(
                                        <div className='spacer_div_vans_list_verified'>
                                            <div className='h3_for_compliance_Page_ralph' onClick={(e, vanItem) => handleMakingMainImage(e, vanDoc.imagesLink, vanDoc)}>
                                                {vanDoc.name}
                                                <img src={pngUrlPdf} alt="Folder" className='image_in_documents_folder'/>
                                            </div>
                                        </div>
                                    )
                                } else {
                                    localArray.push(
                                        <div className='spacer_div_vans_list'>
                                            <div className='h3_for_compliance_Page_ralph' onClick={(e, vanItem) => handleMakingMainImage(e, vanDoc.imagesLink, vanDoc)}>
                                                {vanDoc.name}
                                                <img src={pngUrlPdf} alt="Folder" className='image_in_documents_folder'/>
                                            </div>
                                        </div>
                                    )
                                }
                            } else {
                                // console.log(vanDoc)
                                if (vanDoc.verified === 'True') {
                                    localArray.push(
                                        <div className='spacer_div_vans_list_verified'>
                                            <div className='h3_for_compliance_Page_ralph' onClick={(e, vanItem) => handleMakingMainImage(e, vanDoc.imagesLink, vanDoc)}>
                                                {vanDoc.name}
                                                <img src={vanDoc.imagesLink} alt="Folder" className='image_in_documents_folder'/>
                                            </div>
                                        </div>
                                    )
                                } else {
                                    localArray.push(
                                        <div className='spacer_div_vans_list'>
                                            <div className='h3_for_compliance_Page_ralph' onClick={(e, vanItem) => handleMakingMainImage(e, vanDoc.imagesLink, vanDoc)}>
                                                {vanDoc.name}
                                                <img src={vanDoc.imagesLink} alt="Folder" className='image_in_documents_folder'/>
                                            </div>
                                        </div>
                                    )
                                }
                            }
                        }
                    })
                }
                setVanDocuments(localArray)
            })
        }
    }, [props, rerenderBool])

    // handle submitting document to backend
    var handleSubmit = (e) => {
        e.preventDefault()

        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        if (outsideDocument.length > 0) {
            postData(`https://backendpajamas.herokuapp.com/images/`, {
                imagesLink: outsideDocument,
                name: nameFromList,
                expiryDate: dateSelected.toDateString() === new Date().toDateString() ? 'Mon Sep 9 2052': dateSelected,
                vehicle_id: `https://backendpajamas.herokuapp.com/vehicles/${props.selectedVan.vehicle_id}/`
            }).then( response => {
                if (props.selectedVan.imgArray) {
                    let driverObj = {...props.selectedVan}
                    let localArrayImages = [...driverObj.imgArray, response]
                    driverObj.imgArray = localArrayImages
                    setSubmitted()
                    setValueForSubmit('')
                    setNameFromList('')
                    props.reRender(props.content, driverObj)
                } else {
                    let driverObj = {...props.selectedVan}
                    driverObj['imgArray'] = [response]
                    setSubmitted()
                    setValueForSubmit('')
                    setNameFromList('')
                    props.reRender(props.content, driverObj)
                }
            })
        } else {
            setSubmitPressed('Error')
            setTimeout( () => {
                setSubmitPressed('Submit')
            }, 2000)
        }
    }

    const setSubmitted = () => {
        setSubmitPressed('Added')
        setTimeout( () => {
            setSubmitPressed('Submit')
        }, 2000)
    }

    // make react happy
    const handleChangeCalendar = () => {

    }
    // make react happy
    const handleChangeCalendarTwo = () => {

    }

    // date selection function
    const handleDateSelection = (date) => {
        setDateSelected(date)
        setCalendarGate(false)
    }

    // date selection function
    var theCalendarTwo
    const handleDateSelectionTwo = (date) => {
        setDateSelectedTwo(date)
        setCalendarGateTwo(false)
    }

    // calendar function
    const handleMakingCalendar = () => {
        setCalendarGate(true)
    }

    const handleMakingCalendarTwo = () => {
        setCalendarGateTwo(true)
    }

    // calendar selectiopn function
    const returnDateFunction = (selectedDate) => {
        setDateSelected(selectedDate)
        setCalendarGateTwo(false)
    }
    
    // calendar selectiopn function
    const returnDateFunctionOne = (selectedDate) => {
        setDateSelected(selectedDate)
        setCalendarGate(false)
    }

    // make the calendar
    useEffect( () => {
        if (calendarGate) {
            setTheCalendar(
                <div>
                    <Calendar
                        startingDay='Sun'
                        returnDate={returnDateFunctionOne}
                    />
                </div>
            )
        } else {
            setTheCalendar(null)
        } 
    }, [calendarGate])

    // make the calendar
    if (calendarGateTwo) {
        theCalendarTwo = (
            <div>
                <Calendar
                    startingDay='Sun'
                    returnDate={returnDateFunction}
                />
            </div>
        )
    } 

    // handle selecting name of document
    const handleNameClick = (e, targetName) => {
        setNameFromList(targetName)
        setNameFromListArray([])
        setDisplayNameArray('names_list_array_container_none')
    }

    // handle selecting name of document
    const handleDamageNameClick = (e, targetName) => {
        setDamageNameFromList(targetName)
        setDamageNamesListArray([])
        setDamageDisplayNameArray('names_list_array_container_none')
    }

    // function for making drop down for names list
    const mouseEnterName = () => {
        let localArray = []
        namesListArray.forEach( (ele, id) => {
            localArray.push(
                <div key={id} className='names_in_names_list_array_forms_two' onClick={(e, targetName) => handleNameClick(e, ele)}>
                    <p>{ele}</p>
                </div>    
            )
        })
        setNameFromListArray(localArray)
        setDisplayNameArray('names_list_array_container')
    }

    // function for mouse leaving names list
    const mouseLeaveName = () => {
        setNameFromListArray([])
        setDisplayNameArray('names_list_array_container_none')
    }

    // function for making drop down for names list
    const mouseEnterDamageName = () => {
        let localArray = []
        damageNamesListArrayTwo.forEach( (ele, id) => {
            localArray.push(
                <div key={id} className='names_in_names_list_array_forms_two' onClick={(e, targetName) => handleDamageNameClick(e, ele)}>
                    <p>{ele}</p>
                </div>    
            )
        })
        setDamageNamesListArray(localArray)
        setDamageDisplayNameArray('names_list_array_container')
    }

    // function for mouse leaving names list
    const mouseLeaveDamageName = () => {
        setDamageNamesListArray([])
        setDamageDisplayNameArray('names_list_array_container_none')
    }

    // list of names for documents
    let namesListArray = [
        'TAX',
        'MOT',
        'Motor Insurance',
        'G.I.T. Insurance',
        'P.L. Insurance',
        'V5' 
    ]


    let damageNamesListArrayTwo = [
        'Rental Agreement',
        'Pictures of Damages',
        'Statement',
        'Quote',
        'Invoice'
    ]

    const handleMakingMainImage = (e, source, fullSource, id) => {
        setClassForDiv('submit_files_dissapear')
        setButtonText('Add Document')
        setTimeout( () => {
            setSubmitFilesDivSelection(false)
            setClassForDiv('submit_files')
        }, 1000)
        setCurrentId(id)
        setHighlitedImageDetails(fullSource)
        if (source.includes('.pdf')) {
            let pageString = 'pg_1/'
            let begginingOfUrl = source.slice(0, 53)
            let endOfUrlUrl = source.slice(53)
            let endUrlString = begginingOfUrl.concat(pageString).concat(endOfUrlUrl)
            let pngUrlPdf = endUrlString.replace(/.pdf/, '.png')
            setHighlightedPicture(
            // <img  alt='cannot view' className='big_picture'/>
                <GoogleZoom img={pngUrlPdf}/>
            )
        } else {
            setHighlightedPicture(
            // <img src={source} alt='cannot view' className='big_picture'/>
            <GoogleZoom img={source}/>
            )
        }
    }

    // after the highlighted image screen get the normal divs back 
    const getDivsBack = () => {
        setHighlightedPicture(null)
        setHighlitedImageDetails(null)
        setNewPageNumber(2)
        let driverObj = {...props.selectedVan}
        props.reRender()
    }
    
    // verification process
    const getDivsBackAndVerify = (e) => {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        async function postData(url = '', data = {}) {
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        
        postData(`https://backendpajamas.herokuapp.com/images/${highlightedImageDetails.image_id}/`, {
            verified: 'True'
        }).then( response => {
            let localNum = rerenderBool
            setRerenderBool(localNum + 1)
            setNewPageNumber(2)
            setHighlitedImageDetails(null)
            setHighlightedPicture(null)
        })
    }

    // submit damage report for vehicle
    const handleSubmitDamage = (e) => {
        e.preventDefault()
        let mySubmitObject
        mySubmitObject = {
            statmentOfDamage: textAreaValue.length > 1 ? textAreaValue : 'none',
            name: damageNameFromList,
            vehicle_id: `https://backendpajamas.herokuapp.com/vehicles/${props.selectedVan.vehicle_id}/`,
            dateOfIncident: dateSelectedTwo.toDateString(),
            picturesOfIncident: valueForSubmit ? valueForSubmit : 'no picture'
        }

        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        
        postData(`https://backendpajamas.herokuapp.com/vehicledamages/`, mySubmitObject).then( response => {
            setSubmitted('submitted')
            props.reRender()
        })
    }

    var content

    // verify button
    var verifyButton 
    if (highlightedPicture) {
        if (highlightedImageDetails) {
            if (highlightedImageDetails.verified !== "True") {
                verifyButton = (
                    <div className="btn_picture" onClick={(e, targetImage) => getDivsBackAndVerify(e, highlightedPicture)}>
                    <svg width="125" height="45">
                    <defs>
                        <linearGradient id="grad1">
                            <stop offset="0%" stopColor="#F3F6F6"/>
                            <stop offset="100%" stopColor="#F3F6F6" />
                        </linearGradient>
                    </defs>
                    <rect x="5" y="5" rx="25" fill="none" stroke="url(#grad1)" width="115" height="35"></rect>
                    </svg>
                    <span className='span_in_Button'>Verify</span>  
                </div>  
                )
            }
        }
    }

    // render the damage entry form
    const handleDamageClick = () => {
        setDamageGate(true)
    }

    // handle change
    const handleEnterTextArea = (e) => {
        setTextAreaValue(e.target.value)
    }

    // if pressed make to form to submit new damage documentation
    useEffect( () => {
        if (damageGate) {
            setDamageContent(
                <form onSubmit={handleSubmitDamage} className='form_on_document_page'>
                    <div className='enter_information_documents_vans'>
                        <h3 className='documents_h3'>Upload Image for {props.selectedVan.registration}</h3>
                            <div className='input_information_documents_tab'>
                                <div>
                                    <input type="file" name="file" placeholder="Upload an image" onChange={uploadImage} className='document_input_forms_top'/>
                                    <img src={valueForSubmit ? valueForSubmit : ''} alt="" className='uploaded_image'/>
                                </div>

                                <div className='inner_input_information_documents_tab'>
                                    <h3 className='documents_h3'>Name of Document:</h3>
                                        <input type="text" 
                                        name="theName"  
                                        value={damageNameFromList} 
                                        autoComplete='off' 
                                        className='document_input_forms' 
                                        onMouseEnter={mouseEnterDamageName}
                                        />
                                        <div className={damageDisplayNameArray} onMouseLeave={mouseLeaveDamageName}>
                                            {damageNamesListArray}
                                        </div>
                                </div>
                                <div className='inner_input_information_documents_tab'>
                                    <div className='circleDelete'>
                                        <div className='crossTop'></div>
                                        <div className='crossBottom'></div>
                                    </div>
                                    <h3 className='documents_h3'>Expiry Date:</h3>
                                        <input type="text" name="expiryDate"  className='document_input_forms'value={dateSelectedTwo.toDateString()}  onChange={handleChangeCalendarTwo} autoComplete='off' onClick={handleMakingCalendarTwo}/>
                                        {theCalendarTwo}
                                </div>
                            </div>
                            <br />
                            <h3>Statement</h3>
                            <div>
                                <textarea value={textAreaValue}  onChange={handleEnterTextArea} id="myTextAreaDamages"/>
                            </div>
                            <div className="formsButtonContainer">
                                <div className="button-container-2" id="formsButtonSubmit">
                                    <input type="submit" value={submitPressed} className='compliance_add_driver_button_submit' />
                                </div> 
                            </div>
                    </div>
                </form>
            )
        } else {
            setDamageContent(
                <div className='rightOverallDamages'>
                    <div className='damageDescriptions'>
                        {damageDescriptions}
                    </div>
                    <div className="button-container-2" id="formsButtonSubmit" onClick={handleDamageClick}>
                        <span className='compliance_add_driver_button_submit' >Add Damage</span>
                    </div> 
    
                </div>
            )
        }
    }, [damageGate])


    // remove the delete screen
    const handleDeleteError = () => {
        setDeleteScreen(null)
    }

    // delete a document
    const handleDeleteDocument = (e) => {
        e.preventDefault()
        async function deleteData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'DELETE', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
            });
        };

        deleteData(`https://backendpajamas.herokuapp.com/images/${highlightedImageDetails.image_id}/`).then( response => {
            setDeleteScreen(null)
            getDivsBack()
            let localVar = rerenderBool
            setRerenderBool(localVar + 1)
            props.reRender()
        })
    }

    // function for deleting things
    const deleteImage = (e) => {
        e.preventDefault()
        setDeleteScreen(
            <div className='deleteScreenVanDocs'>
                <h2>Would you like to delete {highlightedImageDetails.name}</h2>
                <div className='docsButtonsContainers'>
                    <button className='errorButtonReturn' onClick={handleDeleteError}>Return</button>
                    <button className='errorButtonSubmit' onClick={handleDeleteDocument}>Delete</button>
                </div>
            </div>
        )
    }

    // remove the date option
    const removeDate = (e) => {
        e.preventDefault()
        dateGate === true ? setDateGate(false) : setDateGate(true)
    }

    // useEffect for removing the adda a date option
    useEffect( () => {
        if (dateGate) {
            setDateContent(
                <div className='inner_input_information_documents_tab'>
                <div className='circleDelete' onClick={removeDate}>
                    <div className='crossTop'></div>
                    <div className='crossBottom'></div>
                </div>
                <h3 className='documents_h3'>Expiry Date:</h3>
                    <input type="text" name="expiryDate"  className='document_input_forms' value={dateSelected.toLocaleDateString('en-GB')}  onChange={handleChangeCalendar} autoComplete='off' onClick={handleMakingCalendar}/>
                    {theCalendar}
                </div>
            )
        } else {
            setDateContent(
                <div className='inner_input_information_documents_tab_two'>
                    <div onClick={removeDate} className='compliance_add_driver_button_submit'>Add Date</div>
                </div>
            )
        }
    }, [dateGate, theCalendar, dateSelected])

    // set date content for original to have it
    useEffect( () => {
        setDateContent(
            <div className='inner_input_information_documents_tab'>
            <div className='circleDelete' onClick={removeDate}>
                <div className='crossTop'></div>
                <div className='crossBottom'></div>
            </div>
            <h3 className='documents_h3'>Expiry Date:</h3>
                <input type="text" name="expiryDate"  className='document_input_forms' value={dateSelected.toLocaleDateString('en-GB')}  onChange={handleChangeCalendar} autoComplete='off' onClick={handleMakingCalendar}/>
                {theCalendar}
            </div>
        )
    }, [])

    const handleNextPage = (e, incomingImage) => {
        let localNumber = newPageNumber+1
        setNewPageNumber(localNumber)
        let highlightedNextData = highlightedPicture.props.img.replace(/\/pg_[\d]+\//, `/pg_${localNumber}/`)
        setHighlightedPicture(
            <GoogleZoom img={highlightedNextData} />
        )
    }

    const handlePreviousPage = (e) => {
        let localNumber = newPageNumber-1
        setNewPageNumber(localNumber)
        let highlightedNextData = highlightedPicture.props.img.replace(/\/pg_[\d]+\//, `/pg_${localNumber}/`)
        setHighlightedPicture(
            <GoogleZoom img={highlightedNextData} />
        )
    }

    useEffect( () => {
        if (highlightedPicture) {
            if (highlightedPicture.props) {
                if (highlightedPicture.props.img.includes('pg_')) {
                    let localPageNumber = highlightedPicture.props.img.match(/\/pg_[\d]+\//)[0]
                    let pageNumber = parseInt(localPageNumber.substring(4, localPageNumber.length-1))


                    if (pageNumber > 1) {
                        let highlightedNextData = highlightedPicture.props.img.replace(/\/pg_[\d]+\//, `/pg_${pageNumber+1}/`)
                        axios.get(highlightedNextData)
                        .then( response => {
                            if (response.status === 200) {
                                setAnotherPage(
                                    <div className='innerButtonStyling'>
                                        <div>
                                            {pageNumber-1}
                                            <button onClick={(e) => handlePreviousPage(e)}>Previous Page</button>
                                        </div>
                                        <div>
                                            {pageNumber}
                                            <button onClick={(e) => handleNextPage(e, highlightedNextData)}>Next Page</button>
                                        </div>
                                    </div>
                                )
                            }
                        })
                        .catch(function (error) {
                            if (error) {
                                setAnotherPage(
                                    <div className='innerButtonStyling'>
                                        <div>
                                            {pageNumber-1}
                                            <button onClick={(e) => handlePreviousPage(e)}>Previous Page</button>
                                        </div>
                                        <div>
                                            <button id='makeButtunNull'></button>
                                        </div>
                                    </div>
                                )
                            }
                        })
                    } else {
                        let highlightedNextData = highlightedPicture.props.img.replace(/\/pg_[\d]+\//, `/pg_${pageNumber}/`)
                        axios.get(highlightedNextData)
                        .then( response => {
                            if (response.status === 200) {
                                setAnotherPage(
                                    <div className='innerButtonStyling'>
                                        <div>
                                            <button id='makeButtunNull'></button>
                                        </div>
                                        <div>
                                            {pageNumber+1}
                                            <button onClick={(e) => handleNextPage(e, highlightedNextData)}>Next Page</button>
                                        </div>
                                    </div>
                                )
                            }
                        })
                        .catch(function (error) {
                            if (error) {
                                setAnotherPage(null)
                            }
                        })
                    }
                }
            }
        }
    }, [highlightedPicture, newPageNumber])

    const addToOldList = (e, theItem) => {
        async function putData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };

        putData(`https://backendpajamas.herokuapp.com/images/${highlightedImageDetails.image_id}/`, {
            storageBool: true,
        }).then( response => {
            getDivsBack()
        })
    }

    // make the update proper
    useEffect( () => {
           // function for submitting files
        if (highlightedPicture) {
            setSubmitFilesDiv(
                <div className='big_picture_div'>
                    <div className='button_div_box_top'>
                        <div>
                            <h3>
                                Document: {highlightedImageDetails.name}
                            </h3>
                            <h3>
                                Verified: {highlightedImageDetails.verified ? 'True' : 'False'}
                            </h3>
                            <h3>
                                Expiry Date: {new Date(highlightedImageDetails.expiryDate).toLocaleString('en-GB')}
                            </h3>
                        </div>
                        <div className='anotherPageButton'>
                            {anotherPage}
                        </div>
                    </div>
                        <div className='highlightedImageContainerForVanDocs'>
                            {highlightedPicture}
                        </div>
                    <div className='button_div_box'>
                        <div className="btn_picture" onClick={getDivsBack}>
                            <svg width="125" height="45">
                            <defs>
                                <linearGradient id="grad1">
                                    <stop offset="0%" stopColor="#F3F6F6"/>
                                    <stop offset="100%" stopColor="#F3F6F6" />
                                </linearGradient>
                            </defs>
                            <rect x="5" y="5" rx="25" fill="none" stroke="url(#grad1)" width="115" height="35"></rect>
                            </svg>
                            <span className='span_in_Button'>Return</span>  
                        </div>   
                        <div className="btn_picture" onClick={(e, targetImage) => addToOldList(e, highlightedPicture)}>
                                <svg width="125" height="45">
                                <defs>
                                    <linearGradient id="grad1">
                                        <stop offset="0%" stopColor="#F3F6F6"/>
                                        <stop offset="100%" stopColor="#F3F6F6" />
                                    </linearGradient>
                                </defs>
                                <rect x="5" y="5" rx="25" fill="none" stroke="url(#grad1)" width="115" height="35"></rect>
                                </svg>
                                <span className='span_in_Button'>Store</span>  
                            </div>
                        <div className="btn_picture" onClick={deleteImage}>
                            <svg width="125" height="45">
                            <defs>
                                <linearGradient id="grad1">
                                    <stop offset="0%" stopColor="#F3F6F6"/>
                                    <stop offset="100%" stopColor="#F3F6F6" />
                                </linearGradient>
                            </defs>
                            <rect x="5" y="5" rx="25" fill="none" stroke="url(#grad1)" width="115" height="35"></rect>
                            </svg>
                            <span className='span_in_Button'>Delete</span>  
                        </div>   
                        {verifyButton}
                    </div>
                </div>
            )
        } else if (props.selectedVan) {
            // console.log('rendering')
            setSubmitFilesDiv(
                <div className='document_vans_container'>
                    <div className='submit_files_three_freedom'>
                        <form onSubmit={handleSubmit} className='form_on_document_page'>
                            <div className='enter_information_documents_vans'>
                                <h3 className='documents_h3'>Upload Image for {props.selectedVan.registration}</h3>
                                    <input type="file" name="file" placeholder="Upload an image" onChange={uploadImage} className='document_input_forms_top'/>
                                    <img src={valueForSubmit ? valueForSubmit : ''} alt="" className='uploaded_image'/>
                                    <div className='input_information_documents_tab'>
                                        <div className='inner_input_information_documents_tab'>
                                            <h3 className='documents_h3'>Name of Document:</h3>
                                                <input type="text" 
                                                name="theName"  
                                                value={nameFromList} 
                                                autoComplete='off' 
                                                className='document_input_forms' 
                                                onMouseEnter={mouseEnterName}
                                                />
                                                <div className={displayNameArray} onMouseLeave={mouseLeaveName}>
                                                    {nameFromListArray}
                                                </div>
                                        </div>
                                    {dateContent}
                                    </div>
                                    <br />
                                <div className="button-container-2" id="formsButtonSubmit">
                                    <input type="submit" value={submitPressed} className='compliance_add_driver_button_submit' />
                                </div> 
                            </div>
                        </form>
                    </div>
                    <div className='van_documents_document_vans'>
                        <h2>Documents for Van</h2>
                        <div>
                            {vanDocuments}
                        </div>
                    </div>
                    <div className='van_documents_document_vans_two'>
                        <h2>Van Damage Documentation</h2>
                        {damageContent}
                    </div>
                </div>
            )
        }
    }, [highlightedPicture, nameFromList, vanDocuments, nameFromListArray, dateContent, damageContent, anotherPage])

 

    return (
        <>
            {deleteScreen}
            {submitFilesDiv}
        </>
    )
}

export default DocumentVans